/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var WeatherUmbrellaIcon16Regular = forwardRef('WeatherUmbrellaIcon16Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M8.75 1.25a.75.75 0 1 0-1.5 0v.74a7.004 7.004 0 0 0-6.165 5.866A.992.992 0 0 0 2.068 9H7.25v3.75a.75.75 0 0 1-.75.75c-.397 0-.75-.273-.75-.694a.75.75 0 0 0-1.5 0C4.25 14.046 5.284 15 6.5 15a2.25 2.25 0 0 0 2.25-2.25V9h5.182a.992.992 0 0 0 .983-1.144A7.004 7.004 0 0 0 8.75 1.99v-.74Zm4.557 6.25a5.503 5.503 0 0 0-10.614 0h10.614Z" })));
});
